import React, { useContext } from "react"
import { StyleSheet, View } from "react-native"
import { ThemeContext } from "../utility/context/ThemeContext"
import { MAX_CONTENT_WIDTH } from "../config"
import { SkeletonBlock, SkeletonCircle, SkeletonGroup, SkeletonLine } from "../utility/skeleton"

export const ManageAccountsSkeleton = ({
  rowCount = 6,
}: {
  rowCount?: number
}): React.ReactElement => {
  const theme = useContext(ThemeContext).theme
  const { bgMain, bgAlt } = theme.colors

  const rows = Math.max(4, Math.min(10, rowCount))

  return (
    <View style={{ flex: 1, backgroundColor: bgMain }}>
      <View style={[styles.header, { maxWidth: MAX_CONTENT_WIDTH }]}>
        <SkeletonGroup>
          <SkeletonLine width="60%" height={18} radius={10} />
          <SkeletonLine width="35%" height={12} radius={8} />
        </SkeletonGroup>
      </View>

      <View style={[styles.list, { maxWidth: MAX_CONTENT_WIDTH }]}>
        <SkeletonGroup>
          {new Array(rows).fill(0).map((_, idx) => (
            <View key={idx} style={[styles.rowCard, { backgroundColor: bgAlt }]}>
              <SkeletonCircle size={18} />
              <View style={{ flex: 1, gap: 8 }}>
                <SkeletonLine width="55%" height={14} radius={8} />
                <SkeletonLine width="35%" height={12} radius={8} />
              </View>
              <SkeletonLine width={80} height={12} radius={8} />
              <SkeletonCircle size={18} />
              {/* color band placeholder on left */}
              <SkeletonBlock style={styles.leftBand} radius={0} />
            </View>
          ))}
        </SkeletonGroup>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  header: {
    paddingHorizontal: 16,
    gap: 8,
    paddingVertical: 16,
    width: "100%",
    alignSelf: "center",
  },
  list: {
    paddingTop: 10,
    paddingHorizontal: 16,
    gap: 10,
    width: "100%",
    alignSelf: "center",
  },
  rowCard: {
    width: "100%",
    paddingHorizontal: 12,
    paddingVertical: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "transparent",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    overflow: "hidden",
  },
  leftBand: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    width: 6,
  },
})

